import { Typography, IconButton, Button, Link } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { makeStyles } from "@material-ui/core/styles";
import { Close } from "@material-ui/icons";


import { InformationalVideo } from "./types";


interface InformationalVideoModalProps {
    video: InformationalVideo;
    open: boolean;
    onClose: () => void;
}

const useStyles = makeStyles(() => ({
    modal: {
        borderRadius: 16,
    },
    modalBody: {
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        padding: 45,
    },
    headerText: {
        fontWeight: 700,
    },
    contentMargin: {
        margin: "7px 0",
    },
    closeButton: {
        position: "absolute",
        right: 10,
        top: 10,
        zIndex: 90,
        backgroundColor: "#00000040",
        color: "white",
        "&:hover": {
            backgroundColor: "#00000060",
        },
    },
}));

const InformationalVideoModal: React.FC<InformationalVideoModalProps> = ({ video, open, onClose }) => {

    const classes = useStyles();

    return (
        <Dialog classes={{ paper: classes.modal }} open={open}>

            <IconButton className={classes.closeButton} onClick={onClose} role="close-button">
                <Close />
            </IconButton>


            <video width="600" height="338" role="video" src={video.video_url} poster={video.thumbnail_url} controls />
            <DialogContent className={classes.modalBody}>
                {video.header_text &&
                    <Typography className={`${classes.contentMargin} ${classes.headerText}`} align="center" variant="h6">{video.header_text}</Typography>
                }
                {video.body_text &&
                    <Typography className={classes.contentMargin} align="center" variant="body1" role="modal-body-text">{video.body_text}</Typography>
                }
                {video.documentation_url &&
                    <Link href={video.documentation_url} underline="none" target="_blank" rel="noopener">
                        <Button className={classes.contentMargin} variant="contained" size="large" color="secondary">MORE INFO</Button>
                    </Link>
                }
            </DialogContent>
        </Dialog>
    );
};

export default InformationalVideoModal;
